/** Funzioni di presentazione dei tag di strategia (SPEC-028), condivise da chip e modale. */

import type { StrategyParams } from './api';

const TIMING_LABEL: Record<string, string> = {
  before_open: "prima dell'apertura",
  during_session: 'in seduta',
  after_close: 'dopo la chiusura',
  unknown: 'orario non noto',
};

function todayKey(now: Date): string {
  return now.toISOString().slice(0, 10);
}

/** La scadenza piu' vicina del tag (evento o revisione), se c'e'. */
export function deadlineOf(params: StrategyParams): string | null {
  const dates = [params.eventDate, params.reviewBy].filter((value): value is string => Boolean(value)).sort();
  return dates[0] ?? null;
}

export function isExpired(params: StrategyParams, now = new Date()): boolean {
  const deadline = deadlineOf(params);
  return deadline !== null && deadline < todayKey(now);
}

export function describeParams(params: StrategyParams): string {
  return [
    params.eventDate ? `evento ${params.eventDate}${params.eventTiming ? ` ${TIMING_LABEL[params.eventTiming] ?? ''}` : ''}` : null,
    params.eventLabel ? `«${params.eventLabel}»` : null,
    params.targetPrice ? `obiettivo ${params.targetPrice}` : null,
    params.stopPrice ? `stop ${params.stopPrice}` : null,
    params.reviewBy ? `revisione entro ${params.reviewBy}` : null,
    params.note ?? null,
  ]
    .filter(Boolean)
    .join(' · ');
}
